import { AttributeFilter } from 'app/shared/ui/models/attribute-filter';
import { RefundedStatus } from '../../../../models/enums/refunded.enum';

export class RefundedStatusAttributeFilter implements AttributeFilter {
  attribute: string;
  label: string;
  operator: string;
  value?: string[];
  tempValue?: string[] | undefined;
  secondValue?: any;

  constructor(attribute: string, label: string, operator: string, value?: string[], secondValue?: any) {
    this.attribute = attribute;
    this.label = label;
    this.operator = operator;
    this.value = value;
    this.secondValue = secondValue;
  }

  updateValue(): any {
    const filters = Object.create({});
    this.value = this.tempValue;
    filters[this.attribute + '.' + this.operator] = this.value;
    return filters;
  }

  isChecked(): boolean {
    return !!(this.tempValue && this.operator);
  }

  htmlButtonText(): string {
    let htmlContent = '<b>' + this.label + '</b> ';
    if (this.operator === 'in') {
      htmlContent += 'est';
    } else {
      htmlContent += '';
    }

    if (this.value?.includes(RefundedStatus.TOTALLY_REFUNDED) || this.value?.includes(RefundedStatus.PARTIALLY_REFUNDED)) {
      htmlContent += ' <b>avec remboursement</b>';
    } else if (this.value?.includes(RefundedStatus.NOT_REFUNDED)) {
      htmlContent += ' <b>sans remboursement</b>';
    }
    return htmlContent;
  }
}
